import { render, staticRenderFns } from "./LookupReport.vue?vue&type=template&id=5b5ff290&scoped=true&"
import script from "./LookupReport.vue?vue&type=script&lang=js&"
export * from "./LookupReport.vue?vue&type=script&lang=js&"
import style0 from "./LookupReport.vue?vue&type=style&index=0&id=5b5ff290&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5ff290",
  null
  
)

export default component.exports